import { urlUtility } from "@repo/utilities/url.utility.ts";
import { TBROKERS } from "#/types/global.types";

function isPartnerFlow() {
  const isAssisted = import.meta.env.VITE_USER !== "customer";
  const urlQueries = urlUtility.getUrlQueries(window.location.href);
  const pageId = urlQueries["page-id"];
  const from = urlQueries["from"];
  const isPartner = isAssisted || (from !== "journey-links" && !!pageId);
  return isPartner;
}

function isCustomerFlow() {
  return import.meta.env.VITE_USER === "customer";
}

function isCurrentBroker(broker: TBROKERS) {
  return (
    (broker === "edme" && import.meta.env.VITE_BROKER === "general") ||
    import.meta.env.VITE_BROKER === broker
  );
}

export { isPartnerFlow, isCustomerFlow, isCurrentBroker };
